<div class="w-full animate-fade-in pb-8 ">
    <!-- Header Shared Component -->
    <app-section-header [title]="isEdit() ? 'Editar Colaborador' : 'Registrar Colaborador'"
        [description]="(business() ? 'Gestión de Negocio' : 'Personal') +' | ' + (isEdit() ? 'Gestión de Acceso' : 'Nueva Invitación')"
        icon="solar:user-rounded-bold-duotone" [showBack]="true">
    </app-section-header>
    <div class="animate-fade-in space-y-4">

        <form [formGroup]="form" (ngSubmit)="save()" class="space-y-4">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">

                <!-- Identidad -->
                <div class="compact-section space-y-3">
                    <div class="flex items-center justify-between">
                        <p
                            class="flex items-center gap-1.5 text-[8px] font-black uppercase tracking-[0.2em] text-foreground/60">
                            <iconify-icon icon="solar:card-2-bold-duotone" width="11"
                                class="text-primary"></iconify-icon>
                            Información de Identidad
                        </p>
                        <!-- Indicator for existing user -->
                        <div *ngIf="userExists()"
                            class="flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-emerald-500/10 text-emerald-500 border border-emerald-500/10 animate-fade-in">
                            <iconify-icon icon="mdi:account-check" width="10"></iconify-icon>
                            <span class="text-[7px] font-black uppercase tracking-widest">Usuario Existente</span>
                        </div>
                    </div>

                    <div class="relative">
                        <app-input label="Correo Electrónico" formControlName="email" type="email" size="sm"
                            icon="solar:letter-bold-duotone" [required]="true" placeholder="juan@clinica.com"
                            [disabled]="isEdit()"></app-input>
                        <!-- Loading spinner for email search -->
                        <div *ngIf="searchingEmail()" class="absolute right-3 top-[32px] flex items-center">
                            <iconify-icon icon="mdi:loading" class="animate-spin text-primary"
                                width="14"></iconify-icon>
                        </div>
                    </div>

                    <div class="relative group">
                        <app-input label="Nombre Completo" formControlName="fullName" size="sm"
                            icon="solar:user-bold-duotone" [required]="true" placeholder="Ej: Juan Pérez"></app-input>
                        <div *ngIf="userExists() && !isEdit()"
                            class="absolute inset-0 bg-transparent cursor-not-allowed"
                            title="Datos del usuario encontrados automáticamente"></div>
                    </div>

                    <!-- User Already in Business Warning -->
                    <div *ngIf="userAlreadyInBusiness() && !isEdit()"
                        class="p-2.5 bg-red-500/10 border border-red-500/20 rounded-xl flex items-center gap-2.5 animate-fade-in">
                        <div class="w-6 h-6 rounded-lg bg-red-500/10 flex items-center justify-center text-red-500">
                            <iconify-icon icon="mdi:alert-circle-outline" width="14"></iconify-icon>
                        </div>
                        <div>
                            <p class="text-[8px] font-black text-red-500 uppercase tracking-tight">Acceso Denegado</p>
                            <p class="text-[7px] font-bold text-red-500/70 uppercase leading-snug">
                                Este usuario ya está vinculado a este negocio.
                            </p>
                        </div>
                    </div>

                    <!-- New User Message -->
                    <div *ngIf="!userExists() && !isEdit() && form.get('email')?.valid && !searchingEmail()"
                        class="p-2.5 bg-primary/5 border border-primary/10 rounded-xl flex items-center gap-2.5 animate-fade-in">
                        <div class="w-6 h-6 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
                            <iconify-icon icon="mdi:account-plus-outline" width="14"></iconify-icon>
                        </div>
                        <p class="text-[8px] font-bold text-primary/70 uppercase leading-snug">
                            Nuevo Usuario: Completa los datos para crear su cuenta institucional.
                        </p>
                    </div>

                    <div *ngIf="!isEdit()"
                        class="p-3 bg-primary/[0.02] border border-primary/5 rounded-lg space-y-3 transition-opacity"
                        [class.opacity-40]="userExists()" [class.pointer-events-none]="userExists()">
                        <p class="text-[7px] font-black uppercase text-primary/60 italic mb-1">
                            {{ userExists() ? 'Usuario ya tiene credenciales' : 'Credenciales iniciales' }}
                        </p>
                        <app-input label="Contraseña Temporal" formControlName="password" type="password" size="sm"
                            [showToggle]="true" [required]="true" icon="solar:lock-bold-duotone"
                            placeholder="Mínimo 6 caracteres"></app-input>
                    </div>
                </div>

                <!--Estado y Contexto -->
                <div class="compact-section space-y-4">
                    <p
                        class="flex items-center gap-1.5 text-[8px] font-black uppercase tracking-[0.2em] text-foreground/60">
                        <iconify-icon icon="solar:settings-bold-duotone" width="11" class="text-primary"></iconify-icon>
                        Estado del Acceso
                    </p>

                    <div
                        class="p-3 bg-foreground/[0.02] border border-foreground/[0.03] rounded-xl flex items-center justify-between">
                        <div class="flex items-center gap-3">
                            <div
                                class="w-8 h-8 rounded-lg bg-surface flex items-center justify-center border border-foreground/[0.05] shadow-sm text-foreground/45">
                                <iconify-icon icon="solar:buildings-2-bold-duotone" width="14"></iconify-icon>
                            </div>
                            <div>
                                <span
                                    class="block text-[8px] font-black uppercase tracking-widest text-foreground/60 mb-0.5">Negocio
                                    Activo</span>
                                <span class="block text-[10px] font-black uppercase text-foreground leading-none">{{
                                    businessName() }}</span>
                            </div>
                        </div>
                        <app-badge variant="primary" class="scale-75 text-primary border-primary/10">Activo</app-badge>
                    </div>

                    <label
                        class="p-3 bg-foreground/[0.01] border border-foreground/[0.03] rounded-xl flex items-center justify-between cursor-pointer hover:bg-foreground/[0.02] transition-colors group">
                        <div class="flex flex-col">
                            <span
                                class="text-[9px] font-bold text-slate-800 dark:text-white/90/50 uppercase tracking-widest group-hover:text-foreground transition-colors">Estado
                                de la cuenta</span>
                            <span
                                class="text-[7px] text-foreground/60 font-bold uppercase tracking-tighter">Habilitar/Deshabilitar
                                ingreso</span>
                        </div>
                        <div class="relative">
                            <input type="checkbox" formControlName="isActive" class="sr-only peer">
                            <div
                                class="w-8 h-4 bg-foreground/10 rounded-full peer peer-checked:bg-primary after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-3 after:w-3 after:transition-all peer-checked:after:translate-x-4 shadow-inner">
                            </div>
                        </div>
                    </label>

                    <label
                        class="p-3 bg-foreground/[0.01] border border-foreground/[0.03] rounded-xl flex items-center justify-between cursor-pointer hover:bg-foreground/[0.02] transition-colors group">
                        <div class="flex flex-col">
                            <span
                                class="text-[9px] font-bold text-slate-800 dark:text-white/90/50 uppercase tracking-widest group-hover:text-foreground transition-colors">Atributo
                                Clínico</span>
                            <span class="text-[7px] text-foreground/60 font-bold uppercase tracking-tighter">Médico /
                                Odontólogo</span>
                        </div>
                        <div class="relative">
                            <input type="checkbox" formControlName="isOdontologist" class="sr-only peer">
                            <div
                                class="w-8 h-4 bg-foreground/10 rounded-full peer peer-checked:bg-primary after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-3 after:w-3 after:transition-all peer-checked:after:translate-x-4 shadow-inner">
                            </div>
                        </div>
                    </label>
                </div>
            </div>

            <!-- Permisos -->
            <div class="compact-section space-y-4">
                <div class="flex items-center justify-between">
                    <div>
                        <p
                            class="flex items-center gap-1.5 text-[8px] font-black uppercase tracking-[0.2em] text-foreground/60 mb-0.5">
                            <iconify-icon icon="solar:shield-check-bold-duotone" width="11"
                                class="text-primary"></iconify-icon>
                            Permisos Directos (Acciones)
                        </p>
                        <span
                            class="text-[8px] font-bold text-foreground/60 uppercase italic tracking-tighter">Selecciona
                            qué puede hacer el colaborador en cada módulo</span>
                    </div>
                    <div
                        class="flex items-center gap-1.5 bg-foreground/[0.02] p-1.5 rounded-lg border border-foreground/[0.03]">
                        <span
                            class="text-[8px] font-black uppercase tracking-tight text-primary/60 px-2 border-r border-foreground/[0.05]">{{
                            selectedActionCount() }} activos</span>
                        <button type="button" (click)="clearActions()"
                            class="px-2 py-1 text-[7px] font-black uppercase hover:text-red-500 transition-colors">Limpiar</button>
                        <button type="button" (click)="selectAllActions()"
                            class="px-2 py-1 bg-surface border border-foreground/[0.05] rounded-md text-[7px] font-black uppercase shadow-sm hover:border-primary/20 hover:text-primary transition-all">Todos
                            los Permitidos</button>
                    </div>
                </div>

                <div class="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-3">
                    <div *ngFor="let mod of availableModules()" class="permission-tile space-y-3">
                        <label class="flex items-center justify-between cursor-pointer group">
                            <div class="flex items-center gap-2 max-w-[80%] overflow-hidden">
                                <div
                                    class="w-5 h-5 rounded bg-primary/5 flex items-center justify-center text-primary/40 group-hover:bg-primary group-hover:text-white transition-colors">
                                    <iconify-icon [attr.icon]="mod.icon" width="12"></iconify-icon>
                                </div>
                                <span
                                    class="text-[9px] font-black uppercase tracking-widest text-foreground/60 group-hover:text-foreground truncate transition-colors">{{
                                    mod.label }}</span>
                            </div>
                            <input type="checkbox" [checked]="isModuleEnabled(mod)" (change)="toggleModule(mod)"
                                class="w-3.5 h-3.5 rounded accent-primary cursor-pointer border-foreground/10 hover:border-primary transition-all">
                        </label>

                        <div class="h-px bg-foreground/[0.03]"></div>

                        <div class="flex flex-wrap gap-1.5">
                            <button *ngFor="let action of mod.actions" type="button" [disabled]="action.default"
                                (click)="toggleAction(mod.module, action.key)"
                                class="px-2 py-1 rounded-md text-[8px] font-black uppercase tracking-tighter transition-all border shadow-sm"
                                [class.bg-primary/5]="isActionSelected(action.full)"
                                [class.border-primary/20]="isActionSelected(action.full)"
                                [class.text-primary]="isActionSelected(action.full)"
                                [class.bg-surface]="!isActionSelected(action.full)"
                                [class.border-foreground/[0.05]]="!isActionSelected(action.full)"
                                [class.text-foreground/60]="!isActionSelected(action.full)">
                                {{ action.label }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex items-center justify-end gap-3 pt-4 border-t border-foreground/[0.03]">
                <div *ngIf="error()"
                    class="mr-auto text-[8px] font-black text-red-500 uppercase tracking-widest bg-red-500/5 px-4 py-2 rounded-xl border border-red-500/10 flex items-center gap-2">
                    <iconify-icon icon="solar:danger-bold-duotone" width="12"></iconify-icon>
                    {{ error() }}
                </div>
                <app-button variant="glass" size="xs" (click)="goBack()" iconLeft="mdi:cancel"
                    class="text-[9px] font-black uppercase px-8 border border-white/5">Cancelar</app-button>
                <app-button type="submit"
                    [disabled]="form.invalid || saving() || selectedActionCount() === 0 || userAlreadyInBusiness()"
                    [loading]="saving()" variant="primary" size="xs"
                    class="text-[10px] font-black uppercase px-10 shadow-lg shadow-primary/20"
                    [iconLeft]="saving() ? 'mdi:check' : (isEdit() ? 'mdi:content-save-outline' : 'mdi:check')"
                    [class.animate-pulse]="saving()">
                    {{ saving() ? 'Procesando...' : (isEdit() ? 'Actualizar Colaborador' : 'Enviar Invitación') }}
                </app-button>
            </div>

        </form>
    </div>
</div>